"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.MulticallWrapper = void 0;
const ethers_multicall_1 = require("ethers-multicall");
const ethers_1 = require("ethers");
const dataloader_1 = __importDefault(require("dataloader"));
// matic mumbai
ethers_multicall_1.setMulticallAddress(80001, '0x41eB847bD788F3219254371212C947793C392374');
ethers_multicall_1.setMulticallAddress(137, '0x11ce4B23bD875D7F5C6a31084f55fDe1e9A87507');
ethers_multicall_1.setMulticallAddress(132333505628089, '0x905Db52890481E40552D9b7429F3419DAF8bC085');
ethers_multicall_1.setMulticallAddress(1032942172, '0xEF5bd9516021770d36E2E3e76737bA848AD79C26');
ethers_multicall_1.setMulticallAddress(1305754875840118, '0x139645624dab0027fdEeb4F23Df66a7b5cCFfE36');
class MulticallWrapper {
    constructor(provider, chainId, dataLoaderOptions = { cache: false }) {
        this.ethcallProvider = new ethers_multicall_1.Provider(provider, chainId);
        this.dataLoader = new dataloader_1.default(this.doCalls.bind(this), dataLoaderOptions);
    }
    async doCalls(calls) {
        return this.ethcallProvider.all(calls);
    }
    async wrap(contract) {
        return this.syncWrap(contract);
    }
    // wrap was original implemented as an async function, but it is no longer needed. However, we do not want to break the interface.
    syncWrap(contract) {
        const abi = contract.interface.fragments;
        const multicallContract = new ethers_multicall_1.Contract(contract.address, abi);
        const dataLoader = this.dataLoader;
        const funcs = abi.reduce((memo, frag) => {
            if (frag.type === 'function') {
                const funcFrag = frag;
                if (['pure', 'view'].includes(funcFrag.stateMutability)) {
                    const multicallFunc = multicallContract[funcFrag.name].bind(multicallContract);
                    const newFunc = (...args) => {
                        const contractCall = multicallFunc(...args);
                        return dataLoader.load(contractCall);
                    };
                    memo[funcFrag.name] = newFunc;
                }
            }
            return memo;
        }, {});
        // The reason we return a new object here rather than a proxy
        // or modifying the original contract is that
        // Contract sets its properties as ReadOnly and so you cannot modify them
        // or else it throws a TypeError
        const newContract = {
            ...contract,
            ...funcs,
        };
        return Object.setPrototypeOf(newContract, ethers_1.Contract.prototype);
    }
}
exports.MulticallWrapper = MulticallWrapper;
MulticallWrapper.setMulticallAddress = ethers_multicall_1.setMulticallAddress;
exports.default = MulticallWrapper;
